document.addEventListener("click", (e) => {
    if (e.target.closest('.m-product-quickview-button')) {
    setTimeout(() => {
        let quickviewElement = document.querySelector('.m-product-quickview');
        let prdTitle = quickviewElement.getAttribute('product-title');
        let numColors = 0;
        let colorSelector = document.querySelectorAll(".color-selector");
        let selectedColorsContainer = document.querySelectorAll(".selected-colors");
        let selectedColorsData = document.querySelectorAll(".selected-colors-data");
        var AtcButtons = quickviewElement.querySelectorAll('.m-add-to-cart');
        var DynamicCheckoutDiv = document.querySelector('.m-product-quickview .m-product-dynamic-checkout');    

        if (quickviewElement && prdTitle && prdTitle.includes('6-Pack')) {
            maxAllowedQty = 6;
            let totalQty = 0;
            defaultQty = 1;
            console.log( prdTitle);
            DynamicCheckoutDiv.style.pointerEvents = 'none';
            DynamicCheckoutDiv.style.opacity= 0.6;
            console.log("DynamicCheckoutDiv",DynamicCheckoutDiv)
            AtcButtons.forEach((button) => {
                button.setAttribute('type', 'button');
                button.addEventListener('click', ()=>{
                    console.log("clicked")
                    if (totalQty < maxAllowedQty) {
                        alert("color select are required")
                        totalQty = 6; 
                    } else{

                    }
                })
            });

        } else if (quickviewElement && prdTitle && prdTitle.includes('3-Pack')) {
            maxAllowedQty = 3;
            defaultQty = 1;
            let totalQty = 0;
            DynamicCheckoutDiv.style.pointerEvents = 'none';
                DynamicCheckoutDiv.style.opacity= 0.6;
                console.log("DynamicCheckoutDiv",DynamicCheckoutDiv)
                AtcButtons.forEach((button) => {
                    button.setAttribute('type', 'button');
                    button.addEventListener('click', ()=>{
                        console.log("clicked");
                        if (totalQty < maxAllowedQty) {
                            alert("color select are required")
                            totalQty=3
                        } else{
    
                        }
                    })
                });
            console.log(prdTitle);
        }

        colorSelector.forEach((colorSelectorEvent)=>{
            colorSelectorEvent.addEventListener("change", function () {
                let selectedColor = this.value;
                console.log("Color Selected: ", selectedColor);
    
                if (selectedColor && !document.getElementById(`qty-${selectedColor}`)) {
                    let colorDiv = document.createElement("div");
                    colorDiv.classList.add("color-item");
                    colorDiv.setAttribute("data-color", selectedColor);
    
                    colorDiv.innerHTML = `
                        <label>${selectedColor}:</label>
                        <input type="number" id="qty-${selectedColor}" class="color-qty" name="properties[${selectedColor}]" 
                            data-color="${selectedColor}" min="0" max="${maxAllowedQty}" value="${defaultQty}">
                        <button type="button" class="remove-color" data-color="${selectedColor}">✖</button>
                    `;
                    selectedColorsContainer.forEach((selectedColors)=>{
                        selectedColors.appendChild(colorDiv);
                    })
                    numColors++;
                    console.log("Number of Colors Selected: ", numColors);
                    updateTotalQuantity();
                    updateBuyButtonData();
                }
    
                this.value = ""; // Reset the color selector value
            });
        })

           // Update buy button data
        function updateBuyButtonData() {
            let buyButtonInput = document.querySelectorAll(".buy-button-selected-colors");
            if (buyButtonInput) {
                buyButtonInput.forEach((button) => {
                    // Collect the values of selectedColorsData and join them as a string
                    button.value = Array.from(selectedColorsData).map((data) => data.value).join(", ");
                });
                
                let stickyBuyButtonInput = document.querySelector("#buy-button-selected-colors_sticky");
                if (stickyBuyButtonInput) {
                    // Collect the values of selectedColorsData and join them as a string
                    stickyBuyButtonInput.value = Array.from(selectedColorsData).map((data) => data.value).join(", ");
                }
            }
        }

         // Disable ATC buttons
        function disableButtons(buttons) {
            buttons.forEach(button => {
                button.setAttribute('type', 'button');
            });
        }

        function adjustQuantities() {
            let remainingQty = maxAllowedQty;
            let quantityInputs = document.querySelectorAll(".color-qty");

            quantityInputs.forEach((input) => {
                let currentQty = parseInt(input.value) || 0;

                if (currentQty > remainingQty) {
                    input.value = remainingQty;
                    remainingQty = 0;
                } else {
                    remainingQty -= currentQty;
                }
            });
            updateTotalQuantity();
        }

        // Enable ATC buttons
        function enableButtons(buttons) {
            buttons.forEach(button => {
                button.setAttribute('type', 'submit');
            });
        }

        selectedColorsContainer.forEach((selectedColors)=>{
            selectedColors.addEventListener("input", function (e) {
                if (e.target.classList.contains("color-qty")) {
                    let inputValue = parseInt(e.target.value) || 0;
                    if (inputValue > maxAllowedQty) {
                        e.target.value = maxAllowedQty;
                    }
                    updateTotalQuantity();
                }
            });
        })


         // Remove selected color
         selectedColorsContainer.forEach((selectedColors)=>{
            selectedColors.addEventListener("click", function (e) {
                if (e.target.classList.contains("remove-color")) {
                    let colorToRemove = e.target.getAttribute("data-color");
                    document.querySelector(`[data-color='${colorToRemove}']`).remove();
                    numColors--;
                    updateTotalQuantity();
                }
            });
        });

         // Update the total quantity and handle button adjustments
        function updateTotalQuantity() {
            totalQty = 0;
            let selectedData = [];
            let colorInputs = document.querySelectorAll(".color-qty");

            colorInputs.forEach(input => {
                let qty = parseInt(input.value) || 0;
                console.log("qty dsdsdsd", qty)
                totalQty += qty;
                console.log("qty", qty);
                if (qty > 0) {
                    console.log("qty", qty);
                    selectedData.push(`${input.getAttribute("data-color")}: ${qty}`);
                }
            });

            // Adjust totalQty logic to prevent exceeding maxAllowedQty
            if (totalQty > maxAllowedQty) {
                alert(`You cannot select more than ${maxAllowedQty} units. Adjusting quantities automatically.`);
                adjustQuantities();
                return;
            } else{

            }

            colorSelector.forEach((colorSelector_V)=>{
                colorSelector_V.disabled = totalQty >= maxAllowedQty;
            })
            selectedColorsData.forEach((data)=>{
                data.value = selectedData.join(", ");
            })
            updateBuyButtonData();

            if (totalQty === maxAllowedQty) {
                colorInputs.forEach(input => {
                    // input.disabled = true;
                });
                hideExcessInputs();
            } else {
                colorInputs.forEach(input => {
                    input.disabled = false;
                    if (parseInt(input.value) === 0) {
                        input.value = defaultQty;
                    }
                });
                colorSelector.forEach((colorSelector_e)=>{
                    colorSelector_e.disabled = false;
                })
                
                showAllInputs();
            }

            let AtcButtons = document.querySelectorAll('.m-add-to-cart');
            if (totalQty < maxAllowedQty) {
                console.log("If condition: Disabling ATC buttons and adding listener.");
                disableButtons(AtcButtons);
                DynamicCheckoutDiv.style.pointerEvents = 'none';
                DynamicCheckoutDiv.style.opacity= 0.6;
                console.log("DynamicCheckoutDiv",DynamicCheckoutDiv)
                AtcButtons.forEach((button) => {
                    button.removeEventListener("click", atcButtonClickHandler); 
                    button.addEventListener("click", atcButtonClickHandler);
                });
            } else if (totalQty === maxAllowedQty) {
                console.log("Else condition: Enabling ATC buttons.");
                enableButtons(AtcButtons);
                DynamicCheckoutDiv.style.pointerEvents = 'auto';
                DynamicCheckoutDiv.style.opacity= 1;
                console.log("DynamicCheckoutDiv",DynamicCheckoutDiv)
                AtcButtons.forEach((button) => {
                    button.removeEventListener("click", atcButtonClickHandler);
                    button.addEventListener("click", atcButtonClickHandler);
                });
            }
        }

          // Handle ATC button click event
        function atcButtonClickHandler() {
            if (totalQty < maxAllowedQty) {
                alert("Color selection is required !!.");
            } else {
                
            }
        }

         // Hide excess inputs when quantity reaches the maxAllowedQty
         function hideExcessInputs() {
            let colorInputs = document.querySelectorAll(".color-qty");
            colorInputs.forEach(input => {
                if (parseInt(input.value) === 0) {
                    input.parentElement.style.display = "none"; // Hide the input
                }
            });
        }

        // Show all inputs
        function showAllInputs() {
            let colorInputs = document.querySelectorAll(".color-qty");
            colorInputs.forEach(input => {
                input.parentElement.style.display = "grid"; // Show the input
            });
        }


    }, 1000);   
    }
  });



